import { forwardRef } from 'react';
import { X } from 'lucide-react';

const SheetCloseButton = forwardRef(function SheetCloseButton({ label = 'Sluiten', inverted = false, className = '', ...props }, ref) {
  return <button {...props} ref={ref} type="button" aria-label={label} className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 ${inverted ? 'text-white hover:bg-white/10 focus-visible:ring-white' : 'text-zinc-500 hover:bg-zinc-100 focus-visible:ring-primary dark:text-zinc-400 dark:hover:bg-zinc-800'} ${className}`}><X size={20} aria-hidden="true" /></button>;
});

export default SheetCloseButton;
